import { useState } from 'react';
import {
  bool,
  element,
  func,
  number,
  object,
  string,
} from 'prop-types';
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogActions,
  Box,
  useTheme,
} from '@material-ui/core';
import {
  Close as CloseIcon,
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon,
} from '@material-ui/icons';

import useStyles from './styles';
import DocumentThumbnailsSidebar from './components/DocumentThumbnailsSidebar';
import DocumentActionsBar from './components/DocumentActionsBar';

function ModalFileViewer(props) {
  const {
    children,
    open,
    title,
    actions,
    thumbs,
    onDownload,
    handleWidthSize,
    handleRotate,
    inputValue,
    setInputValue,
    zoomSize,
    onClose,
    pdfConfig,
    setPdfConfig,
  } = props;
  
  const classes = useStyles();
  const [forceFull, setForceFull] = useState(false);
  const theme = useTheme();

  const handleOpenInNewTab = () => {
    if (pdfConfig.contentUrl) {
      window.open(pdfConfig.contentUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Dialog
      id={'principalModal'}
      aria-labelledby="dialog-title"
      fullScreen={forceFull}
      open={open}
      className={classes.borderModal}
      PaperProps={{
        style: {
          width: forceFull ? '100dvw' : '90dvw',
          height: forceFull ? '100dvh' : '90dvh',
          maxWidth: 'none',
          display: 'flex',
          flexDirection: 'column',
          transition: 'all 0.3s ease',
        },
      }}
    >
      <DialogTitle
        children={title || 'Previsualización'}
        id="dialog-title"
        className={classes.centeredTitle}
        color='primary'
        style={{
          backgroundColor: theme.palette.primary.main,
          color: 'white',
          flexShrink: 0,
        }}
      />

      <IconButton
        aria-label="fullscreen"
        className={classes.secondButton}
        onClick={() => setForceFull((prev) => !prev)}
        style={{
          color: 'white',
        }}
      >
        {forceFull ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </IconButton>

      <IconButton
        aria-label="close"
        className={classes.firstButton}
        onClick={onClose}
        style={{
          color: 'white',
        }}
      >
        <CloseIcon />
      </IconButton>

      {actions && (
        <DialogActions
          style={{ 
            display: 'flex',
            justifyContent: 'space-between',
            flexShrink: 0,
          }}
        >
          <DocumentActionsBar
            pdfConfig={pdfConfig}
            setPdfConfig={setPdfConfig}
            onRotateLeft={() => handleRotate(false)}
            onRotateRight={() => handleRotate(true)}
            handleWidthSize={handleWidthSize}
            zoomSize={zoomSize}
            onDownload={onDownload}
            onOpenInNewTab={handleOpenInNewTab}
            inputValue={inputValue}
            setInputValue={setInputValue}
          />
        </DialogActions>
      )}

      <Box
        style={{
          display: 'flex',
          ...(thumbs && { 
            flex: '1 1 auto',
          }),
          overflow: 'hidden',
          height: '100%',
          minHeight: 0,
        }}
      >
        {thumbs && pdfConfig.subType !== 'word' && pdfConfig.is && pdfConfig.numPages > 1 && (
          <DocumentThumbnailsSidebar
            pdfConfig={pdfConfig}
            setPdfConfig={setPdfConfig}
          />
        )}

        <Box
          style={{
            flex: 1,
            overflow: 'auto',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'lightgray',
            padding: 0,
            minHeight: 0,
          }}
        >
          {children}
        </Box>
      </Box>
    </Dialog>
  );
}

ModalFileViewer.defaultProps = {
  events: {},
  open: false,
  onDownload: () => {},
  onZoomIn: () => {},
  onZoomOut: () => {},
  zoomSize: 600,
  onReset: () => {},
};

ModalFileViewer.propTypes = {
  children: element,
  onClose: func,
  open: bool,
  actions: bool,
  thumbs: bool,
  title: string,
  onDownload: func,
  handleWidthSize: func,
  handleRotate: func,
  inputValue: string,
  setInputValue: func,
  zoomSize: number,
  pdfConfig: object,
  setPdfConfig: func,
};

export default ModalFileViewer;
